import { Dayjs } from 'dayjs'

export class Bookmark {
  isFromOrganization?: boolean

  constructor(
    public id: string,
    public name: string,
    public creationTime?: Dayjs
  ) {}

  isPoint() {
    return 'position' in this && !this.isFromOrganization
  }

  isExtent() {
    return !this.isPoint()
  }
}
